<div id="liste-globale" class="home">
  <div class="my-3 my-md-5">
    <div class="container-fluid">
      <app-bon-de-commande [bdc]="bdc"></app-bon-de-commande>
    </div>
  </div>
</div>
